<template>
  <b-container class="mt-3 mt-md-5">
    <b-row>
      <b-col col sm="12">
        <b-card no-body>
          <div class="card shadow">
            <div class="card-header bg-transparent m-0 p-0">
              <h3 class="float-left mb-0">
                {{ $t('message.add') + ' ' + $t('message.medicalAdvice') }}
              </h3>
              <div class="card-body m-0 p-0">
                <b-container fluid class="m-0 p-0">
                  <br>
                  <b-form class="mt-4">
                    <b-row class="p-0">
                        <b-col sm="12">
                            <span class="obligatoire">*</span>
                            <b-form-group id="activity-group" :label="$t('message.activity')" label-for="activity">
                                <multiselect v-model="$v.form.activity_id.$model" :options="missions" :multiple="true" :close-on-select="true" :clear-on-select="false" :preserve-search="true" :placeholder="$t('message.activities')" label="description_fr" track-by="id"></multiselect>
                                <b-form-invalid-feedback v-if="$v.form.activity_id.$error">
                                    {{ $t('message.requiredField') }}
                                </b-form-invalid-feedback>
                                <span v-if="errorshasField('activity_id')" style="color:red">
                                    {{getErrorsField('activity_id')}}
                                </span>
                            </b-form-group>
                        </b-col>
                    </b-row>
                    <b-row class="mt-3">
                      <b-col md="12" sm="12">
                        <span class="obligatoire">*</span>

                        <b-form-group
                            id="patient-group"
                            :label="$t('message.select')+' '+$tc('message.patients',1)"
                            label-for="patient">
                          <!-- Options -->
                          <select id="patient" v-model="$v.form.patient_id.$model" required
                                  class="form-control is-invalid border-light retirerBordure"
                          >
                            <option v-for="item in mPatients" :value="item.value" :key="item.value">
                              {{ item.text }}
                            </option>
                          </select>

                          <b-form-invalid-feedback v-if="errorshasField('patient_id')">
                            {{ getErrorsField('patient_id') }}
                          </b-form-invalid-feedback>

                          <b-form-invalid-feedback v-if="$v.form.patient_id.$error">
                            {{ $t('message.requiredField') }}
                          </b-form-invalid-feedback>

                        </b-form-group>
                      </b-col>
                    </b-row>

                    <b-row>
                      <b-col md="12" sm="12">
                        <b-form-group
                            id="motif-group"
                            :label="$tc('message.objectAdvice',1)"
                            label-for="objectAdvice">
                          <b-form-input
                              id="objectAdvice"
                              v-model="$v.form.object.$model"
                              :state="$v.form.object.$dirty ? !(errorshasField('object') || $v.form.motifs.$error) : null"
                              placeholder=""
                          ></b-form-input>
                          <b-form-invalid-feedback v-if="errorshasField('object')">
                            {{ getErrorsField('object') }}
                          </b-form-invalid-feedback>

                          <b-form-invalid-feedback v-if="$v.form.object.$error">
                            {{ $t('message.requiredField') }}
                          </b-form-invalid-feedback>

                        </b-form-group>

                      </b-col>
                    </b-row>

                    <b-row>
                      <b-col md="12" sm="12">
                        <b-form-group
                            id="motif-group"
                            :label="$tc('message.description',1)"
                            label-for="motif">
                          <editor
                            :api-key="tinyKey"
                            id="motif"
                            v-model="$v.form.description.$model"
                            :state="$v.form.description.$dirty ? !(errorshasField('description') || $v.form.description.$error) : null"
                            placeholder=""
                            @focus="clearErrorField('description')"
                            :init="{height: 200, menubar: false, plugins: plugins, toolbar: toolbar}">
                          </editor>
                          <b-form-invalid-feedback v-if="errorshasField('description')">
                            {{ getErrorsField('description') }}
                          </b-form-invalid-feedback>

                          <b-form-invalid-feedback v-if="$v.form.description.$error">
                            {{ $t('message.requiredField') }}
                          </b-form-invalid-feedback>

                        </b-form-group>

                      </b-col>
                    </b-row>
                    <b-row>
                      <b-col md="12" sm="12">
                        <b-form-group
                            id="specialties-group"
                            :label="$tc('message.doctorsAdvice',2)"
                            label-for="doctors"
                        >
                          <select
                              id="doctors"
                              v-model="$v.form.doctors.$model"
                              @change="clearErrorField('doctors')"
                              class="form-control is-invalid retirerBordure"
                              required
                              multiple
                          >
                            <option data-placeholder="true"></option>
                            <option v-for="item in mContributors" :key="item.id" :value="item.id">
                              {{ item.nom }}
                            </option>
                          </select>
                          <span v-if="errorshasField('doctors')" style="color:red">
                                                              {{getErrorsField('doctors')}}
                                                          </span>
                        </b-form-group>
                      </b-col>
                    </b-row>

                    <b-row class="mt-3">
                      <b-col md="12" sm="12">
                        <b-form-group
                            id="patient-group"
                            :label="$t('message.select')+' '+$t('message.emergencyCode')"
                            label-for="emergencyCode">
                          <!-- Options -->
                          <select id="emergencyCode" v-model="$v.form.emergencyCode.$model" required
                                  class="form-control is-invalid border-light retirerBordure"
                          >
                            <option v-for="(item, key) in emergencyCodeList" :value="item" :key="key">
                              {{ item }}
                            </option>
                          </select>

                        </b-form-group>
                      </b-col>
                    </b-row>

                    <!--<b-row class="mt-3">
                        <b-col md="12" sm="12">
                            <span class="obligatoire">*</span>

                            <b-form-group
                                    id="responsable-group"
                                    :label="$t('message.select')+' '+$t('message.manager')"
                                    label-for="responsable">
                                &lt;!&ndash; Options &ndash;&gt;
                                <select id="responsable" v-model="$v.form.responsable.$model" required
                                        class="form-control is-invalid border-light"
                                >
                                    <option v-for="item in mContributors" :value="item.id" :key="item.id">
                                        {{ item.nom }}
                                    </option>
                                </select>

                                <b-form-invalid-feedback v-if="errorshasField('responsable')">
                                    {{ getErrorsField('responsable') }}
                                </b-form-invalid-feedback>

                                <b-form-invalid-feedback v-if="$v.form.responsable.$error">
                                    {{ $t('message.requiredField') }}
                                </b-form-invalid-feedback>

                            </b-form-group>
                        </b-col>
                    </b-row>-->

                    <b-row>
                      <b-col md="12" sm="12" class="text-center">
                        <b-button @click="onSubmit" variant="primary">
                          {{ $t('message.save') }}
                        </b-button>
                      </b-col>
                    </b-row>
                  </b-form>
                </b-container>
              </div>
            </div>
          </div>
        </b-card>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import * as _ from "lodash";
import {mapGetters} from "vuex";
import SlimSelect from "slim-select";
import {required} from 'vuelidate/lib/validators';
import Editor from '@tinymce/tinymce-vue';
import AppConfig from "../../constants/AppConfig";
import Multiselect from 'vue-multiselect'

export default {
  name: "AddMedicalAdvice",
  components: {
    editor: Editor,
    Multiselect
  },

  computed: {
    ...mapGetters([
      "practitioners",
      "controlDoctors",
      "patients",
    ]),

    mPatients: function() {
      let pArray = [];

      _.forEach(this.patients, function(patient) {
        if (typeof patient.user == 'object' && !_.isNull(patient.user) && patient.user.isMedicasure){
          let user = patient.user;
          if (typeof patient.dossier == "object"){
            let dossier  = patient.dossier;
            let prenom = (user.prenom != null && user.prenom) ?  user.prenom : '' ;
            prenom =  prenom.toLowerCase();
            let text = (user.nom).toUpperCase()+" "+ prenom.charAt(0).toUpperCase() + prenom.substring(1);
            if(!_.isNull(patient.dossier)){
              pArray.push({text: text, value: patient.dossier.id });
            }
          }
        }
      });

      return pArray;
    },

    mPractitioners: function() {
      let pArray = [];

      _.forEach(_.orderBy(this.practitioners,['created_at'],['desc']), function(practitioner) {
        let p = {};
        // if((typeof practitioner.user == 'object') && (!_.isNull(practitioner.user)) && practitioner.user.isMedicasure == '1'){
        if((typeof practitioner.user == 'object') && (!_.isNull(practitioner.user)) && ((practitioner.user.isMedicasure == '0' || practitioner.user.isNotice == '1') || (practitioner.user.isMedicasure || practitioner.user.isNotice == '1'))){
          let prenom = practitioner.user.prenom != 'null' && !_.isNull(practitioner.user.prenom) ? practitioner.user.prenom : '';
          prenom =  prenom.toLowerCase();
          p.nom =  (practitioner.user.nom).toUpperCase() + " "+ prenom.charAt(0).toUpperCase() + prenom.substring(1);
          p.id = practitioner.user.id;
          p.isNotice = practitioner.user.isNotice
          if (p.nom.length >0){
            pArray.push(p);
          }
        }

      });

      return pArray;
    },

    mDoctors: function() {
      let dArray = [];

      _.forEach(_.orderBy(this.controlDoctors,['created_at'],['desc']), function(doctor) {
        let d = {};
        // if((typeof doctor.user == 'object') && (!_.isNull(doctor.user)) && doctor.user.isMedicasure == '1'){
        if((typeof doctor.user == 'object') && (!_.isNull(doctor.user)) && doctor.user.isMedicasure== '0'){
          let prenom = doctor.user.prenom != null ?  doctor.user.prenom : "";
          prenom =  prenom.toLowerCase();
          d.nom =  (doctor.user.nom).toUpperCase() + " "+ prenom.charAt(0).toUpperCase() + prenom.substring(1);
          d.id = doctor.user.id;
          d.isNotice = doctor.user.isNotice

          if (d.nom.length >0){
            dArray.push(d);
          }
        }

      });

      return dArray;
    },

    mContributors:function () {
      let cArray = [];
      //return cArray.concat(this.mPractitioners);
      cArray = cArray.concat(this.mDoctors,this.mPractitioners).filter(user => user.isNotice == 1);
      return cArray;
    }
  },

  data() {
    return {
      missions: [],
      form:{
        patient_id: '',
        bindToPatientMedicalFolder: '',
        description: '',
        activity_id: '',
        object: '',
        emergencyCode: '',
        doctors: [],

        // this field is hidden and its value if filled automatically
        slug: '',
      },
      emergencyCodeList: [
        'Normal',
        'Urgent',
        'Ultra urgent',
      ],
      offset: 0,
      limit: -1,
      showTable: true,
      tinyKey: AppConfig.tinyMceKey,
      plugins : [
        'advlist autolink lists image charmap',
        'searchreplace visualblocks code fullscreen',
        'print preview anchor insertdatetime media',
        'paste code help wordcount table'
      ],
      toolbar : 'undo redo | formatselect | bold italic | \
                           alignleft aligncenter alignright | \
                           bullist numlist outdent indent | help',
    };
  },
  methods: {
    getGroupeActivites: function () {
        axios
            .get(AppConfig.apiUrl + "/mission/list")
            .then((res) => {this.missions = res.data.activites.map((x )=> ({
                id: x.id,
                description_fr: x.description_fr
            }))})
            .catch((error) => {window.console.log(error)});
    },

    onSubmit() {
      event.preventDefault();
      // console.log('form => ', this.form);
      event.preventDefault();
      this.$v.$touch();

      if (!this.$v.$invalid ) {
        const args = {};
        args.dossier_medical_id = this.form.patient_id;
        args.objet = this.form.object;
        args.description = this.form.description;

        if (this.form.emergencyCode && this.form.emergencyCode.length > 0) {
          args.code_urgence = this.form.emergencyCode;
        } else args.code_urgence = this.emergencyCodeList[0];

        args.creer_lien = '1';

        args.medecins = this.form.doctors;

        const successMessage = this.$i18n.t('message.medicalAdviceCreated');
        const errorMessages = {
          generic: this.$i18n.t('message.genericError'),
          error: this.$i18n.t('message.genericError') // TODO: Prendre message approprié
        };

        const actionToPerform = 'createMedicalAdvice';

        const payload = { args, errorMessages, successMessage };

        this.$store.dispatch(actionToPerform, payload).then(() => {

        });
      }
    },

    getPatients: function() {
      this.$store.dispatch('getPatients', { args: {} });
    },

    getDoctors() {
      let args = {
        offset: this.offset,
        limit: this.limit
      };

      this.$store.dispatch('getControlDoctors', { args : args });
    },

    getPractitioners() {
      let args = {
        offset: this.offset,
        limit: this.limit
      };

      this.$store.dispatch('getPractitioners', { args : args });
    },

    errorshasField(field) {
      return this.errors ? this.errors.hasOwnProperty(field) : false;
    },

    clearErrorField(field) {
      this.$store.dispatch('clearErrorField', {field});

      this.errorshasField(field);
    }
  },
  validations() {
    return {
      form: {
        activity_id:{
                    required
                },
        patient_id:{
          required
        },

        bindToPatientMedicalFolder:{

        },

        emergencyCode:{

        },

        description:{
          required
        },

        object:{
          required
        },

        doctors:{
          // required
        }
      }
    }
  },
  mounted() {
    this.getGroupeActivites();
    this.getPatients();

    // Fetch control doctor list
    this.getDoctors();

    // Fetch practitioner list
    this.getPractitioners();

    new SlimSelect({
      select: '#patient',
      // placeholder: 'Select doctors',
      limit: 1
    });

    new SlimSelect({
      select: '#doctors',
      placeholder: 'Select doctors',
      limit: 5
    });

    new SlimSelect({
      select: '#emergencyCode',
      // placeholder: 'Select doctors',
      limit: 1
    });
  }
}
</script>





<style scoped lang="scss">

</style>
